import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import { getFieldValue, getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export default function ModuleTeasers({
  data,
  editing,
  className,
  onChange,
  onAddNewChild,
  origData,
  stable,
}: IEntityComponentProps) {
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const gridType = content.field_grid_type;
  const moduleClasses = clsx({ ...className.module }, 'relative');
  const containerClasses = clsx({ ...className.container }, 'px-0', 'relative');
  const teaserColumnClass = clsx('col', 'col-12', 'u-margin-bottom-teaser', {
    'col-xl-4': gridType !== 2,
    'col-xl-6': gridType === 2,
  });
  const childModuleIds = getRelatedEntityIds(data, 'field_items');
  const childModuleIdsLength = childModuleIds.length - 1;

  return (
    <div className={moduleClasses} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={containerClasses}>
        <div className="row c-module__header">
          <div className="col col-12">
            <EditableField
              hide={getFieldValue<boolean>(data, 'attributes.field_hide_title')}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={getFieldValue<string>(data, 'attributes.field_title.value')}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className="c-module__content">
          {!content.field_hide_text && content.field_text ? (
            <div className="row">
              <div className="col col-12 col-md-8 u-margin-top-sm mb-4">
                <EditableField
                  hide={getFieldValue<boolean>(data, 'attributes.field_hide_text')}
                  entityType={data.type}
                  fieldName="attributes.field_text.value"
                  data={getFieldValue<string>(data, 'attributes.field_text.value')}
                  editing={editing}
                  onChange={onChange}
                />
              </div>
            </div>
          ) : null}
          <div className="row">
            {childModuleIds.map((id, i) => {
              return (
                <div key={i} className={teaserColumnClass}>
                  <DraggableModuleContainer
                    parentIsStable={stable}
                    index={i}
                    key={id}
                    entityId={id}
                    parentContext={data.id}
                    parentType={data.type}
                    fieldName="relationships.field_items.data"
                    siblingsLength={childModuleIdsLength}
                    canMove={editing}
                  />
                </div>
              );
            })}
            {editing && (
              <div className={teaserColumnClass}>
                <AddLink
                  onClick={() =>
                    onAddNewChild({
                      id: origData,
                      fieldName: 'relationships.field_items.data',
                      templateType: 'paragraph--teasers_item',
                    })
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
